/**
 * THE ONE DEFINITION OF THE `['dispatch-jobs', params]` READ.
 *
 * Dispatch and the Overview both read GET /dispatch/jobs, and an unfiltered
 * board's `params` is `{}` — so both land on `['dispatch-jobs', {}]`, ONE cache
 * entry. Until this file each wrote its own shape into it: Dispatch stored
 * `{ jobs, tenantToday }`, the Overview stored the bare array. Whichever
 * fetched first won, and the other read the wrong shape. Dispatch → Overview
 * handed `buildActionAlerts` an object and `jobs.filter is not a function`
 * took down the whole app.
 *
 * So the queryFn lives here and the cache holds exactly one shape. A reader
 * that wants something else derives it with `select` — which runs per
 * observer and never writes to the cache — rather than with its own queryFn.
 * The key is kept, not split: a dozen mutations invalidate `['dispatch-jobs']`
 * so the Overview refreshes with the board, and `useCrewWriteMutation`
 * patches every entry under it assuming this shape.
 */
import { api } from '../api/client';
import type { DispatchJob } from '../types/dispatch';

export type DispatchJobsCache = { jobs: DispatchJob[]; tenantToday: string | null };

export const dispatchJobsQueryKey = (params: Record<string, string>) => ['dispatch-jobs', params] as const;

export const fetchDispatchJobs = (params: Record<string, string>): Promise<DispatchJobsCache> =>
  api.dispatch.jobs(params).then((r) => ({
    jobs: r.data.data.jobs ?? [],
    tenantToday: r.data.data.tenant_today ?? null,
  }));
